module.exports = __webpack_public_path__ + "img/cart--pink.bb557520.svg";